/** @jsx jsx */
import { jsx } from '@emotion/react'
import { Fragment } from 'react'
import { culturaStyle, diferenciaisStyle } from '../assets/styles/InternasContent.styles'
import { Col, Container, Row } from 'react-bootstrap'
import ImgCultura from '../assets/images/LP-arabe/img-cultura-1.png'
import ImgDiferencial2 from '../assets/images/LP-arabe/img-cultura-2.png'
import BgMobile from '../assets/images/LP-arabe/bg-cultura-m.png'

const HeaderContent = () => {
  return (
    <Fragment>
      <section css={culturaStyle}>
        <div>
          <img src={BgMobile} className="img-mobile" />
        </div>
        <Container>
          <Row className='title-sec'>
            <Col lg={6} md={6} sm={12}>
              <h1>Aprender para se integrar: cultura que une gerações</h1>
              <p className='p-bottom'>As tradições, as curiosidades e as histórias também fortalecem os laços entre escola, família e comunidade.</p>
            </Col>
          </Row>
        </Container>
      </section>
      <section css={diferenciaisStyle}>
        <Container className='diferencias-sec'>
          <Row data-aos="fade-down" data-aos-delay="500">
            <Col lg={7} md={7} sm={12}>
              <h2>Um convite ao conhecimento, à <span>identidade</span> e ao pertencimento</h2>
              <p>O quiz é mais do que uma atividade interativa, é uma forma de aproximar a comunidade escolar da rica herança árabe. Na Escola Árabe Bertoni, diariamente, buscamos incentivar a descoberta, o conhecimento e o respeito pelas raízes que nos conectam. E mais:</p>
              <ul>
                <li>- Enaltecer o orgulho pela identidade cultural</li>
                <li>- Fortalecer os laços entre gerações</li>
                <li>- Promover conhecimento e respeito mútuo</li>
                <li>- Envolver famílias e alunos em um ambiente de troca e integração</li>
              </ul>
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={4} md={4} sm={12}>
              <img src={ImgCultura} alt='Educação que prepara para liderar e prosperar' />
            </Col>
          </Row>
          <Row data-aos="fade-down" data-aos-delay="500" className='row-2'>
            <Col lg={7} md={7} sm={12}>
              <img src={ImgDiferencial2} className="d-none d-md-block" alt='Educação que prepara para liderar e prosperar' />
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={4} md={4} sm={12}>
              <h3>Como a comunidade participa?</h3>
              <ul>
                <li>- Eventos culturais: Festivais, oficinas de caligrafia árabe e noites de contação de histórias.</li>
                <li>- Voluntariado: Pais e membros da comunidade compartilham habilidades e conhecimentos.</li>
                <li>- Feedback contínuo: Suas opiniões (como as do quiz!) ajudam a moldar nossos projetos pedagógicos.</li>
              </ul>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <img src={ImgDiferencial2} className="d-block d-md-none row-2" alt='Educação que prepara para liderar e prosperar' />
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>

  )
}

export default HeaderContent
